module.exports = __webpack_public_path__ + "static/img/ewm_04.50bb50c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewm_04.png
// module id = AgtL
// module chunks = 46